import { QuantumchatWidget } from './widget.js';
import { enrichConfigWithShoperData, isShoperStore } from './integrations/shoper.js';

// Load external CSS file
function loadStyles() {
  if (!document.getElementById('quantumchat-widget-styles')) {
    const scripts = document.querySelectorAll('script[src*="quantumchat-widget"]');
    if (scripts.length > 0) {
      const scriptSrc = (scripts[0] as HTMLScriptElement).src;
      const baseUrl = scriptSrc.substring(0, scriptSrc.lastIndexOf('/'));
      const linkElement = document.createElement('link');
      linkElement.id = 'quantumchat-widget-styles';
      linkElement.rel = 'stylesheet';
      let suffix = '';
      try {
        const u = new URL(scriptSrc);
        suffix = u.search || '';
      } catch {}
      linkElement.href = `${baseUrl}/style.css${suffix}`;
      document.head.appendChild(linkElement);
    }
  }
}

// Auto-initialize if script has data-* attributes
document.addEventListener('DOMContentLoaded', () => {
  loadStyles();
  const scripts = document.querySelectorAll('script[src*="quantumchat-widget"]');
  scripts.forEach(script => {
    const apiUrl = script.getAttribute('data-api-url');
    const siteId = script.getAttribute('data-site-id');
    const widgetKey = script.getAttribute('data-widget-key') || 'default';
    const debug = script.getAttribute('data-debug') === 'true';

    if (apiUrl && siteId) {
      // Bazowa konfiguracja z data-* atrybutów
      let config: Record<string, any> = {
        apiUrl,
        siteId,
        widgetKey,
        customerId: script.getAttribute('data-customer-id') || undefined,
        customerEmail: script.getAttribute('data-customer-email') || undefined,
        customerName: script.getAttribute('data-customer-name') || undefined,
        customerType: script.getAttribute('data-customer-type') || undefined,
        companyName: script.getAttribute('data-company-name') || undefined,
        companyId: script.getAttribute('data-company-id') || undefined,
        theme: (script.getAttribute('data-theme') as 'light' | 'dark') || 'light',
        position: (script.getAttribute('data-position') as 'bottom-right' | 'bottom-left') || 'bottom-right',
        primaryColor: script.getAttribute('data-primary-color') || '#990000',
        translationEnabled: script.getAttribute('data-translation-enabled') !== 'false',
        welcomeMessage: script.getAttribute('data-welcome-message') || undefined,
        headerTitle: script.getAttribute('data-header-title') || undefined,
        inputPlaceholder: script.getAttribute('data-input-placeholder') || undefined,
        autoIdentify: script.getAttribute('data-auto-identify'),
        openOn: (script.getAttribute('data-open-on') as 'click' | 'hover') || 'click',
        debug
      };

      // Automatyczna identyfikacja dla platform e-commerce
      if (isShoperStore()) {
        config = enrichConfigWithShoperData(config);
        if (debug) {
          console.debug('[Chataptor] Shoper store detected, customer data enriched');
        }
      }

      const widget = new QuantumchatWidget(config);

      // Store widget instance globally for debugging
      if (!window.quantumchatWidgets) {
        window.quantumchatWidgets = {};
      }
      window.quantumchatWidgets[widgetKey] = widget;

      // Initialize the widget (create UI and connect)
      widget.init().catch(error => {
        console.error('Failed to initialize widget:', error);
      });
    }
  });
});

// Export for manual initialization and TypeScript
declare global {
  interface Window {
    QuantumchatWidget: typeof QuantumchatWidget;
    quantumchatWidgets?: Record<string, QuantumchatWidget>;
  }
}

window.QuantumchatWidget = QuantumchatWidget;

export { QuantumchatWidget };
export default QuantumchatWidget;
